/**
 * Styled Components - Created by gustavomedina on 04/05/18.
 */
import Icon from 'antd/lib/icon'
import styled from 'styled-components'
import { GREEN, GRAY, BLUE, FACEBOOKBLUE, WHITE, RED, BLACK } from '../../theme/colors'

type StyleProps = {
  onlyRead?: boolean
}

export const Container = styled.li`
  list-style-type: none;
  display: flex;
  flex-direction: row;
  position: relative;
  margin-bottom: 10px;
  width: 100%;
  background: ${WHITE};
  border-radius: 5px;
  box-shadow: 1px 2px 5px -2px #d6d6d6;
  @media (max-width: 640px) {
    flex-direction: column;
    margin-bottom: 40px;
  }
`

export const ImageContainer = styled.div`
  position: relative;
  width: fit-content;
  height: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const ItemDetails = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media (max-width: 640px) {
    flex-direction: row;
    position: relative;
  }
`

export const ItemDetailsMobile = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media (max-width: 640px) {
    flex-direction: column;
    position: relative;
  }
`

export const ItemDetailsHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  padding-left: 18px;
  padding-right: 18px;
  padding-top: 10px;

  @media (max-width: 640px) {
    flex-direction: column;
    justify-content: space-around;
  }
`

export const NameContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const PriceContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const ItemDetailsHeaderName = styled.div`
  color: #5f6062;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0.23px;
  line-height: 25px;
  text-transform: uppercase;
  @media(max-width: 767px) {
    font-size: 14px;
  }
  @media(max-width: 480px) {
    font-size: 13px;
  }
  @media(max-width: 380px) {
    font-size: 12px;
  }
`

export const ItemDetailsHeaderNameDetail = styled.div`
  color: #5f6062;
  font-size: 14px;
  letter-spacing: 0.18px;
  line-height: 22px;
  @media(max-width: 767px) {
    font-size: 13px;
  }
  @media(max-width: 480px) {
    font-size: 12px;
  }
  @media(max-width: 380px) {
    font-size: 11px;
  }
`

export const ItemDetailsHeaderPrice = styled.div`
  color: #5f6062;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.11px;
  line-height: 22px;
  text-align: right;

  @media (max-width: 640px) {
    text-align: left;
  }
`

interface ItemDetailsHeaderProps {
  highlighted?: boolean
}

export const ItemDetailsHeaderPriceDetail = styled.div`
  color: ${({ highlighted }: ItemDetailsHeaderProps) =>
    highlighted ? GREEN : GRAY};
  font-size: 12px;
  letter-spacing: 0.13px;
  line-height: 14px;
  text-align: right;

  @media (max-width: 640px) {
    text-align: left;
  }
`

export const HeaderPriceDetailEmpty = styled.div`
  height: 14px;
`

export const ItemDetailsContent = styled.div``

export const Image = styled.img`
  object-fit: cover;
  user-select: none;
  height: 170.29px;
  width: 150.44px;
  background-color: #f1f4f5;
  opacity: 0.85;
  border-radius: 3px;
  ${({ onlyRead }: StyleProps) => (!onlyRead ? 'cursor: pointer' : '')};
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
  @media only screen and (max-width: 640px) {
    height: 137px;
    width: 100%;
    max-width: 196px;
    margin: 0;
    object-fit: cover;
  }
`

export const FooterItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  @media (max-width: 640px) {
    margin-top: 12px;
  }
`

export const AddMore = styled.div`
  color: #5f6062;
  font-size: 16px;
  letter-spacing: 0.11px;
  line-height: 22px;
  cursor: pointer;
  padding-right: 16px;
`

export const DeleteItem = styled.div`
  margin-top: 20px;
  color: #e61737;
  font-size: 12px;
  letter-spacing: 0.09px;
  line-height: 16px;
  cursor: pointer;
  padding-right: 16px;

  @media (max-width: 640px) {
    margin-top: 1em;
  }
`

export const BottomDivider = styled.div`
  box-sizing: border-box;
  height: 1px;
  width: 100%;
  background-color: #dcdcdc;
  margin-right: 16px;
  margin-bottom: 17px;
  margin-top: 19px;
`

export const FromTeamStore = styled.div`
  margin-bottom: 10px;
`

export const StoreLink = styled.div`
  display: inline-block;
  text-decoration: underline;
  color: ${BLUE};
  cursor: pointer;
  transition: all .25s;
  &:hover {
    color: ${FACEBOOKBLUE};
  }
`

export const TestPrintIcon = styled.img`
  max-width: 22px;
  position: absolute;
  left: 12px;
  bottom: ${({ onlyRead }: StyleProps) => onlyRead ? '10px' : '50px'};
  @media (max-width: 640px) {
    bottom: 10px;
  }
`

export const RemoveButton = styled.div`
  position: absolute;
  bottom: 15px;
  right: 18px;
  color: ${RED};
  font-size: 12px;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.9;
  }
`

export const TicketDiv = styled.div`
  position: absolute;
  bottom: 15px;
  right: 18px;
  font-size: 11px;
  display: flex;
  flex-flow: column-reverse;
  align-items: flex-end;
`

export const TicketLink = styled.a`
  font-size: 14px;
  margin-bottom: 2px;
  color: ${BLUE};
`

export const CertificationButton = styled.div`
  user-select: none;
  background-color: #ffee6dad;
  font-size: 12px;
  line-height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  padding: 3px 16px;
  width: 87%;
  margin-top: 10px;
  transition: all .25s;
  position: absolute;
  color: ${BLACK};
  text-align: center;
  &:hover {
    cursor: pointer;
    background-color: #ffee6dd9;
  }
`

export const CertificationButton2 = styled.div`
  user-select: none;
  background-color: #ffee6dad;
  font-size: 12px;
  line-height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  padding: 5px 16px;
  width: 87%;
  margin-top: 10px;
  transition: all .25s;
  position: absolute;
  color: ${BLACK};
  text-align: center;
  &:hover {
    cursor: pointer;
    background-color: #ffee6dd9;
  }
`

export const ProCertifiedLabel = styled.div`
  user-select: none;
  background-color: #38d0e8a6;
  font-size: 12px;
  line-height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  padding: 5px 16px;
  width: 87%;
  margin-top: 10px;
  transition: all .25s;
  position: absolute;
  color: ${BLACK};
  text-align: center;
  &:hover {
    cursor: pointer;
    background-color: #ffee6dd9;
  }
`

export const NotesDiv = styled.div`
  margin-left: 18px;
  margin-top: 10px;
  color: #8a80bc;
  font-size: 13px;
`

export const EditNotes = styled.div`
  font-size: 11px;
  font-weight: 500;
  color: #855cad;
  font-family: Avenir;
  transition: all .25s;
  margin-bottom: 12px;
  margin-left: 18px;
  border: 1px solid #cfbddf;
  border-radius: 3px;
  padding: 2px 4px;
  width: fit-content;
  margin-top: 18px;
  &:hover {
    cursor: pointer;
    background: rebeccapurple;
    color: ${WHITE};
    i {
      color: ${WHITE};
    }
  }
`

export const EditIcon = styled(Icon)`
  transition: all .25s;
  margin-right: 6px;
  color: rebeccapurple;
  transition: all .25s;
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/CartListItemPrint/styledComponents.tsx